import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatIconModule } from '@angular/material/icon';
import { GroupsSharedModule } from '@app/groups/groups-shared.module';
import { OrgsSharedModule } from '@app/orgs/orgs-shared.module';
import { ModalComponent } from '@app/shared/components/modal/modal.component';
import { SelectComponent } from '@app/shared/components/select/select.component';
import { TagsEditComponent } from '@app/tags/components/tags-edit/tags-edit.component';
import { OutcomeNotificationService } from '@app/user-content/user-outcome/services/outcome-notification.service';
import { UserModule } from '@app/user/user.module';
import { PascalCasePipe } from '@degreed/core/pipes';
import { TrapFocusDirective } from '@degreed/lxp/services';
import { NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { GlobalAddResultsComponent } from './global-add-results/global-add-results.component';
import { UserOutcomeImageUploadAdapter } from './services/adapters/user-outcome-image-upload.adapter';
import { ArticleGlobalAddInputFacade } from './user-input-v2/inputs/article/services/global-add/article-global-add.facade';
import { CourseGlobalAddFacade } from './user-input-v2/inputs/course/services/global-add/course-global-add.facade.service';
import {
  ExperienceMapperService,
  ExperienceNotificationService,
  ExperienceService,
  ExperienceTrackerService,
} from './user-input-v2/inputs/experience/services';
import { ExperienceGlobalAddInputFacade } from './user-input-v2/inputs/experience/services/global-add/experience-global-add.facade';
import { VideoGlobalAddInputFacade } from './user-input-v2/inputs/video/services/global-add/video-global-add.facade';
import { CourseFormDomainService } from './user-input/course-form/course-form-domain.service';
import { ImageUrlService } from './user-input/services/image-url.service';
import {
  AccomplishmentMapperService,
  AccomplishmentService,
  AccomplishmentTrackerService,
} from './user-outcome/outcomes/accomplishment/services';
import { AccomplishmentGlobalAddFacade } from './user-outcome/outcomes/accomplishment/services/global-add/accomplishment-global-add.facade';
import { AwardMapperService } from './user-outcome/outcomes/award/services/award-mapper.service';
import { AwardService } from './user-outcome/outcomes/award/services/award.service';
import { AwardGlobalAddFacade } from './user-outcome/outcomes/award/services/global-add/award-global-add.facade';
import {
  BadgeMapperService,
  BadgeService,
  BadgeTrackerService,
} from './user-outcome/outcomes/badge/services';
import { BadgeGlobalAddFacade } from './user-outcome/outcomes/badge/services/global-add/badge-global-add.facade';
import { CertificateMapperService } from './user-outcome/outcomes/certificate/services/certificate-mapper.service';
import { CertificateTrackerService } from './user-outcome/outcomes/certificate/services/certificate-tracker.service';
import { CertificateService } from './user-outcome/outcomes/certificate/services/certificate.service';
import { CertificateGlobalAddFacade } from './user-outcome/outcomes/certificate/services/global-add/certificate-global-add.facade';
import {
  DegreeMapperService,
  DegreeService,
  DegreeTrackerService,
} from './user-outcome/outcomes/degree/services';
import { DegreeGlobalAddFacade } from './user-outcome/outcomes/degree/services/global-add/degree-global-add.facade';
import { OutcomesService } from './user-outcome/services/outcomes.service';

/** A module for user content related items such as User Inputs and Achievements (a.k.a Outcomes) */
@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    GroupsSharedModule,
    OrgsSharedModule,
    UserModule,
    MatDatepickerModule,
    MatIconModule,
    NgbTypeaheadModule,
    SelectComponent,
    PascalCasePipe,
    GlobalAddResultsComponent,
    TrapFocusDirective,
    ModalComponent,
    TagsEditComponent,
  ],
  providers: [
    UserOutcomeImageUploadAdapter,
    CourseFormDomainService,
    ImageUrlService,
    AccomplishmentGlobalAddFacade,
    AccomplishmentMapperService,
    AccomplishmentService,
    AccomplishmentTrackerService,
    OutcomesService,
    ExperienceGlobalAddInputFacade,
    ExperienceMapperService,
    ExperienceNotificationService,
    ExperienceTrackerService,
    ExperienceService,
    OutcomesService,
    CertificateGlobalAddFacade,
    CertificateMapperService,
    CertificateTrackerService,
    CertificateService,
    OutcomesService,
    ExperienceGlobalAddInputFacade,
    ExperienceMapperService,
    ExperienceNotificationService,
    ExperienceTrackerService,
    ExperienceService,
    BadgeGlobalAddFacade,
    BadgeService,
    BadgeMapperService,
    BadgeTrackerService,
    DegreeGlobalAddFacade,
    DegreeService,
    DegreeMapperService,
    DegreeTrackerService,
    OutcomeNotificationService,
    AwardGlobalAddFacade,
    AwardService,
    AwardMapperService,
    VideoGlobalAddInputFacade,
    ArticleGlobalAddInputFacade,
    CourseGlobalAddFacade,
  ],
})
export class UserContentModule {}
